import {
  CareerRole_MerchandisingJobCategory as CareerRoleCategory,
  CareerRole_PathwayLevel as ProficiencyLevel,
} from '__generated__/graphql-types';

import _t from 'i18n!nls/unified-common';

/**
 * @description
 */
export const getDropdownMenuProps = () => ({
  defaultValue: ProficiencyLevel.Beginner,
  label: _t('Filter by'),
  options: [
    {
      value: ProficiencyLevel.Beginner,
      label: _t('Beginner'),
    },
    {
      value: ProficiencyLevel.Intermediate,
      label: _t('Intermediate'),
    },
    {
      value: ProficiencyLevel.Advanced,
      label: _t('Advanced'),
    },
  ],
});

export const getChipFilters = () => [
  {
    id: 'all',
    filterName: _t('Popular'),
  },
  {
    id: CareerRoleCategory.SoftwareAndIt,
    filterName: _t('Software Engineering & IT'),
  },
  {
    id: CareerRoleCategory.Business,
    filterName: _t('Business'),
  },
  {
    id: CareerRoleCategory.SalesAndMarketing,
    filterName: _t('Sales & Marketing'),
  },
  {
    id: CareerRoleCategory.DataAndAnalytics,
    filterName: _t('Data Science & Analytics'),
  },
  {
    id: CareerRoleCategory.Healthcare,
    filterName: _t('Healthcare'),
  },
];

/**
 * @description Generates a cache key for the dropdown value and chip index. Used so we do not need to make repetitive API calls
 */
export const generateCacheKey = (dropdownValue: ProficiencyLevel, chipIndex: number) => {
  return `${dropdownValue}-${chipIndex}`;
};
